import { EntityIdentifierError } from 'lib/errors';
import { getEntityRangeIds } from 'lib/misc';
import { TableCellAlignment, TableEntityIdRetriever } from './types';

/**
 * Calculate cell alignment CSS property value
 *
 * @param {TableCellAlignment} align Alignment definition value
 */
export const getCellAlignment = (align?: TableCellAlignment): 'center' | 'flex-end' | 'flex-start' => {
  switch (align) {
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    case 'left':
    default:
      return 'flex-start';
  }
};

/**
 * Default entity identifier retriever
 *
 * @param {*} entity Source entity
 */
export const getEntityId = <TEntity extends object>(entity: TEntity): string => {
  if ('id' in entity) {
    return (entity as any).id;
  }
  return "";
};

/**
 * Get list of entity identifiers matching the specified range boundaries
 *
 * @param {Array} entities Source list of entities
 * @param {number} startIndex Range start index
 * @param {number} endIndex Range end index
 * @param {Function} getEntityId Entity identifier extractor
 */
export const getSelectionRangeIds = <TRow>(
  entities: Array<TRow>,
  startIndex: number,
  endIndex: number,
  getEntityId: TableEntityIdRetriever<TRow>,
) => getEntityRangeIds(entities, startIndex, endIndex, getEntityId);
